module.exports = __webpack_public_path__ + "static/media/trash.a3e4c2f7.svg";